import { z } from "zod";

const OTP_LENGTH = 6;
const PHONE_LOCAL_MIN_LENGTH = 9;
const PHONE_LOCAL_MAX_LENGTH = 10;

const onlyDigits = (value: string): string => {
  let result = "";
  for (const char of value) {
    if (char >= "0" && char <= "9") {
      result += char;
    }
  }
  return result;
};

const isValidSignupPhone = (value: string): boolean => {
  if (!value) return false;
  const trimmed = value.trim();
  const digits = onlyDigits(trimmed);
  if (trimmed.startsWith("+") && !trimmed.startsWith("+84")) return false;
  if (digits.startsWith("84")) {
    const local = digits.slice(2);
    return (
      local.length >= PHONE_LOCAL_MIN_LENGTH &&
      local.length <= PHONE_LOCAL_MAX_LENGTH
    );
  }
  if (digits.startsWith("0")) {
    const local = digits.slice(1);
    return (
      local.length >= PHONE_LOCAL_MIN_LENGTH &&
      local.length <= PHONE_LOCAL_MAX_LENGTH
    );
  }
  return false;
};

const isValidOtp = (value: string): boolean => {
  if (value.length !== OTP_LENGTH) return false;
  return value.split("").every((char) => char >= "0" && char <= "9");
};

export const loginSchema = z.object({
  email: z
    .string()
    .min(1, "Vui lòng nhập Email hoặc Số điện thoại")
    .refine(
      (value) => isValidSignupPhone(value) || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value),
      "Định dạng không hợp lệ (cần Số điện thoại hoặc Email)"
    ),
  password: z.string().min(8, "Mật khẩu phải có ít nhất 8 ký tự"),
});

export const signupSchema = loginSchema.extend({
  phone: z
    .string()
    .min(1, "Số điện thoại là bắt buộc")
    .refine((value) => isValidSignupPhone(value), {
      message: "Số điện thoại không hợp lệ",
    }),
  email: z.union([z.literal(""), z.string().regex(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, "Email không hợp lệ")]).optional(),
  otp: z
    .string()
    .optional()
    .refine((value) => value === undefined || isValidOtp(value), {
      message: "OTP phải có 6 ký tự",
    }),
  fullName: z.string().min(2, "Tên phải có ít nhất 2 ký tự").optional(),
});

export type LoginInput = z.infer<typeof loginSchema>;
export type SignupInput = z.infer<typeof signupSchema>;
